import type { Intersection } from 'utility-types'

import { type CybusDetailedVolume, type CybusVolume, StatusType } from '../../../../../../domain'

import type { BackendDefinition } from '../../../../../Connectware'
import { mapResourceNames } from '../../../../mappers'

export const mapBaseVolume = ({
    CreatedAt,
    Name,
}: BackendDefinition<'container-manager', 'DockerVolumeResponse'>): Intersection<CybusVolume, CybusDetailedVolume> => {
    const [service, name] = mapResourceNames(Name)
    return { name, id: Name, service, created: new Date(CreatedAt), status: StatusType.ONLINE }
}
